export class CountName {
  month: {
    one: string;
    few: string;
    many: string;
  }
}